import { unreadonly } from '../../../types/unreadonly';
import type { EnumColumnOptionKeyTypes } from '../../columns';
import type { TableFilterBase } from '../TableFilter';
import { filterOperators } from '../operators';

const selectFilterOperators = unreadonly([
  ...filterOperators.select,
  ...filterOperators.empty,
  ...filterOperators.column,
  ...filterOperators.color,
] as const);

export type SelectFilterOperator = (typeof selectFilterOperators)[number];

export type SelectFilterOption = {
  label: string;
  value: string;
};

export type SelectTableFilter = TableFilterBase & {
  type: 'select';
  multi: boolean;
  options: SelectFilterOption[];
  optionKeyType: EnumColumnOptionKeyTypes;
};

export const createSelectFilter = (
  options: SelectFilterOption[],
  multi = false,
  optionKeyType: EnumColumnOptionKeyTypes = 'string',
): SelectTableFilter => ({
  type: 'select',
  multi,
  operators: selectFilterOperators,
  options,
  optionKeyType,
});
